/**
 * Outreach Inbox API – bounce and unsubscribe processing.
 */
import api from '../../../api';

const PREFIX = '/api/outreach/inbox';

export interface ProcessInboxRequest {
  sender_account_id: string;
  max_messages?: number;
  query?: string;
  /** When true, only scan since last sync (default). Set full_sync for a complete rescan. */
  incremental?: boolean;
  full_sync?: boolean;
}

export interface ProcessInboxResponse {
  processed_count: number;
  new_events_count: number;
  leads_suppressed_count: number;
}

export const outreachInboxApi = {
  processBounces: async (request: ProcessInboxRequest): Promise<ProcessInboxResponse> => {
    const { data } = await api.post<ProcessInboxResponse>(`${PREFIX}/process-bounces`, request);
    return data;
  },

  processUnsubscribes: async (request: ProcessInboxRequest): Promise<ProcessInboxResponse> => {
    const { data } = await api.post<ProcessInboxResponse>(`${PREFIX}/process-unsubscribes`, request);
    return data;
  },

  bulkSuppressBounces: async (emails?: string[]): Promise<Record<string, number>> => {
    const { data } = await api.post<Record<string, number>>(`${PREFIX}/bulk-suppress-bounces`, {
      emails: emails ?? null,
      create_missing: true,
    });
    return data;
  },

  bulkUnsubscribe: async (emails?: string[]): Promise<Record<string, number>> => {
    const { data } = await api.post<Record<string, number>>(`${PREFIX}/bulk-unsubscribe`, {
      emails: emails ?? null,
      create_missing: true,
    });
    return data;
  },
};
